(() => {
  if (window.__auBundleDisclosure) return;
  window.__auBundleDisclosure = true;

  const VISIBLE_CARDS = 2;
  const CARD_SLIVER_PX = 6;
  const COLLAPSED_FALLBACK_PX = 240;
  const SELECTOR =
    ".bundle-widget__container, .multi-variant-bundle__container";
  const CARDS =
    ".bundle-widget__product-card, .multi-variant-bundle__product-card";

  function visibleCards(box) {
    return [...box.querySelectorAll(CARDS)].filter(
      (c) => c.getBoundingClientRect().height > 0,
    );
  }

  function collapsedHeight(box) {
    const cards = visibleCards(box);
    if (cards.length > VISIBLE_CARDS) {
      const last = cards[VISIBLE_CARDS - 1];
      const h =
        Math.round(
          last.getBoundingClientRect().bottom - box.getBoundingClientRect().top,
        ) + CARD_SLIVER_PX;
      return Math.max(120, h);
    }
    return COLLAPSED_FALLBACK_PX;
  }

  function setState(box, btn, collapse) {
    if (collapse) {
      box.style.maxHeight = box.scrollHeight + "px";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          box.style.maxHeight = collapsedHeight(box) + "px";
        });
      });
    } else {
      box.style.maxHeight = box.scrollHeight + "px";
    }
    box.classList.toggle("is-collapsed", collapse);
    btn.setAttribute("aria-expanded", String(!collapse));
    btn.firstElementChild.textContent = collapse ? "See more" : "See less";
  }

  function setup(box) {
    if (box.dataset.auDisclosure) return;
    if (box.querySelectorAll(CARDS).length <= VISIBLE_CARDS) return;
    box.dataset.auDisclosure = "1";
    if (!box.id) box.id = "au-bundle-" + Math.random().toString(36).slice(2, 8);
    box.classList.add("au-disclosable");

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "au-see-more";
    btn.setAttribute("aria-controls", box.id);
    btn.appendChild(document.createElement("span"));
    box.insertAdjacentElement("afterend", btn);

    box.addEventListener("transitionend", (e) => {
      if (e.target === box && !box.classList.contains("is-collapsed")) {
        box.style.maxHeight = "none";
      }
    });

    btn.addEventListener("click", () => {
      const collapse = !box.classList.contains("is-collapsed");
      setState(box, btn, collapse);
      if (collapse) btn.scrollIntoView({ block: "nearest" });
    });

    let reclampScheduled = false;
    const reclamp = () => {
      if (reclampScheduled) return;
      reclampScheduled = true;
      requestAnimationFrame(() => {
        reclampScheduled = false;
        if (box.classList.contains("is-collapsed"))
          box.style.maxHeight = collapsedHeight(box) + "px";
      });
    };
    box.querySelectorAll("img").forEach((img) => {
      if (!img.complete) img.addEventListener("load", reclamp, { once: true });
    });
    if ("ResizeObserver" in window) {
      const inner = box.firstElementChild || box;
      new ResizeObserver(reclamp).observe(inner);
    }
    window.addEventListener("load", reclamp, { once: true });

    box.classList.add("is-collapsed");
    btn.setAttribute("aria-expanded", "false");
    btn.firstElementChild.textContent = "See more";
    box.style.maxHeight = collapsedHeight(box) + "px";
  }

  function init(root) {
    (root.querySelectorAll ? root.querySelectorAll(SELECTOR) : []).forEach(
      setup,
    );
    if (root.matches && root.matches(SELECTOR)) setup(root);
  }

  const boot = () => init(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
